<template>
  <footer class="footer">
    <div class="container-fluid">
      <div class="copyright pull-right">
        &copy; {{ $t('footer.codedWith') }}
        <i class="fa fa-heart heart"></i> {{ $t('footer.by') }}
        <a href="https://www.TRBO.com" target="_blank" rel="noopener">TRBO</a>.
        <span>{{ $t('footer.designedBy') }} <a href="https://www.TRBO.com" rel="noopener" target="_blank">TRBO</a>.</span>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
